export default __webpack_public_path__ + "static/media/24.5087f839.png";